import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const Check = (props) => {
  const { height, width, fill, stroke, className } = props;
  return (
    <svg
      id="checkmark"
      width={width}
      height={height}
      fill={fill}
      stroke={stroke}
      className={className}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M.372 7.848a.5.5 0 000 .707l4.317 4.318.607.606a.5.5 0 00.707 0l.607-.606 9.01-9.01a.5.5 0 000-.707l-.607-.607a.5.5 0 00-.707 0L5.65 11.205 1.686 7.241a.5.5 0 00-.707 0l-.607.607z"
      />
      <mask id="checkmark-mask" maskUnits="userSpaceOnUse" x="0" y="2" width="16" height="12">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M.372 7.848a.5.5 0 000 .707l4.317 4.318.607.606a.5.5 0 00.707 0l.607-.606 9.01-9.01a.5.5 0 000-.707l-.607-.607a.5.5 0 00-.707 0L5.65 11.205 1.686 7.241a.5.5 0 00-.707 0l-.607.607z"
          fill="#fff"
        />
      </mask>
    </svg>
  );
};
/* eslint-enable max-len */
Check.defaultProps = {
  className: null,
};

Check.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  stroke: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default Check;
